module.exports = __webpack_public_path__ + "colour-in-Pink.1f9c601150abde92867a.png";